import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    position: 'relative',
  },
  textField: {
    cursor: 'auto',
    width: '100%',
  },
  inputWrapper: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    width: '100%',
    position: 'relative',
  },
  inputWrapperOutlined: {
    padding: 10,
  },
  inputWrapperFilled: {
    padding: '23px 8px 10px',
  },
  chip: {
    margin: theme.spacing(0.5, 1, 0.5, 0),
    overflow: 'hidden',
  },
  chipsInput: {
    backgroundColor: 'transparent',
    color:
      theme.palette.mode === 'dark' ? theme.palette.common.white : undefined,
    outline: 'none',
    border: 0,
    padding: '6px 0 7px',
    flexGrow: 1,
    fontSize: 16,
    flexBasis: theme.spacing(6),
    '&::placeholder': {
      color:
        theme.palette.mode === 'light' ? theme.palette.grey[600] : undefined,
    },
  },
  chipsInputOutlined: {
    padding: '8.5px 4px',
    '&::placeholder': {
      color:
        theme.palette.mode === 'dark' ? theme.palette.primary.main : undefined,
    },
  },
  chipsInputFilled: {
    padding: '4px 4px 0',
    '&::placeholder': {
      color:
        theme.palette.mode === 'dark' ? theme.palette.primary.main : undefined,
    },
  },
  arrowIconStandard: {
    position: 'absolute',
    right: -3,
    bottom: 1,
  },
  arrowIconOutlined: {
    position: 'absolute',
    right: 5,
    top: '50%',
    transform: 'translateY(-50%)',
  },
}));
